"use client";

import Image from "next/image";
import { useTranslations } from "next-intl";

const IMAGE_BASE = "/image/new-version/casting/Low-Pressure-Die-Casting/Why-Choose";

const CARDS = [
	{
		keyPrefix: "whyChooseCard1",
		image: `${IMAGE_BASE}/guaranteed-precision-quality.webp`,
		bg: "bg-black",
		text: "text-white",
		index: "/01",
	},
	{
		keyPrefix: "whyChooseCard2",
		image: `${IMAGE_BASE}/rapid-project-execution.webp`,
		bg: "bg-[#2f8f2f]",
		text: "text-white",
		index: "/02",
	},
	{
		keyPrefix: "whyChooseCard3",
		image: `${IMAGE_BASE}/expert-customization-support.jpg`,
		bg: "bg-[#a8cf86]",
		text: "text-white",
		index: "/03",
	},
] as const;

export default function WhyChooseLowPressureDieCasting() {
	const t = useTranslations("new-low-pressure-casting");

	return (
		<section className="bg-white py-8 sm:py-10 md:py-12 lg:py-16">
			<div className="container">
				<header className="mb-6 text-center sm:mb-8 md:mb-10 lg:mb-12">
					<h2 className="mb-3 text-2xl font-bold leading-tight text-black sm:mb-4 sm:text-[30px] md:text-4xl">
						{t("whyChooseTitle")}
					</h2>
					<p className="mx-auto text-sm leading-relaxed text-black md:text-base">{t("whyChooseDesc")}</p>
				</header>

				<div className="grid grid-cols-1 gap-6 sm:grid-cols-2 lg:grid-cols-3">
					{CARDS.map((card) => (
						<article key={card.keyPrefix} className="flex flex-col overflow-hidden">
							<div className="relative aspect-[16/8] w-full overflow-hidden">
								<Image
									src={card.image}
									alt={t(`${card.keyPrefix}Alt`)}
									fill
									className="object-cover"
									sizes="(max-width: 640px) 100vw, (max-width: 1024px) 50vw, 33vw"
								/>
							</div>
							<div className={`flex flex-1 flex-col px-5 py-6 sm:px-6 sm:py-7 ${card.bg} ${card.text}`}>
								<span className="mb-1 text-sm font-medium opacity-80 sm:text-base">{card.index}</span>
								<h3 className="mb-3 text-lg font-bold sm:text-xl md:text-2xl">
									{t(`${card.keyPrefix}Title`)}
								</h3>
								<p className="text-sm leading-relaxed md:text-base">{t(`${card.keyPrefix}Desc`)}</p>
							</div>
						</article>
					))}
				</div>
			</div>
		</section>
	);
}
